import { render, staticRenderFns } from "./goodForm.vue?vue&type=template&id=63e37709&scoped=true"
import script from "./goodForm.vue?vue&type=script&lang=js"
export * from "./goodForm.vue?vue&type=script&lang=js"
import style0 from "./goodForm.vue?vue&type=style&index=0&id=63e37709&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e37709",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/python/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e37709')) {
      api.createRecord('63e37709', component.options)
    } else {
      api.reload('63e37709', component.options)
    }
    module.hot.accept("./goodForm.vue?vue&type=template&id=63e37709&scoped=true", function () {
      api.rerender('63e37709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/good/goodForm.vue"
export default component.exports